export default __webpack_public_path__ + "static/media/good6-detail-1.9d4840ad.png";